import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlanFeatureService {
  public identiBasePlusPlanName = 'identiBasePlus';
  public identiAlertPlanName = 'identiAlert';
  public identiFindPlanName = 'identiFind';

  public plansFeatures = {
    identiBasePlus: [
      {
        content: 'Secure data storage',
      },
      {
        content: 'Unlimited changes to your pet’s information',
      },
      {
        content: 'Access to our Missing Pet Helpline',
      },
    ],
    identiAlert: [
      {
        content: '24/7 priority access to our Missing Pet Helpline',
      },
      {
        content: 'Pet finder alerts sent to vets, wardens and police in your local area',
      },
      {
        content: 'SMS alerts sent to identibase customers in your area',
      },
      {
        content: 'Missing pet support, advice and materials',
      },
    ],
    identiFind: [
      {
        content: 'Real time pet location tracking with a 2-in-1 PitPat GPS tracker',
      },
      {
        content: 'Award-winning activity monitoring to track exercise, distance & rest',
      },
    ],
  };

  public mainCardContent = [
    {
      imgSrc: '/assets/images/main-plan-card/missingSearch.png',
      text: `Instant contact when your missing pet’s chip is scanned`,
    },
    {
      imgSrc: '/assets/images/main-plan-card/sms.png',
      text: '20-mile missing pet report broadcast to vets, wardens and police',
    },
    {
      imgSrc: '/assets/images/main-plan-card/guidance.png',
      text: '24/7 help & support via our dedicated hotline',
    },
    {
      imgSrc: '/assets/images/main-plan-card/mobiliseComm.png',
      text: 'SMS broadcast to other identi pet keepers in a 5 mile radius',
    },
    {
      imgSrc: '/assets/images/main-plan-card/poster.png',
      text: 'Instant, personalised posters & social media posts',
    },
    {
      imgSrc: '/assets/images/main-plan-card/idIcon.png',
      text: 'Keep your details up to date in our app so we can contact you faster',
    },
  ];

  public mainCardContentForIndorCat = [
    {
      imgSrc: '/assets/images/main-plan-card/idIcon.png',
      text: 'All the coverage of identibase+ and be contacted when {petName}’s microchip is scanned.',
    },
    {
      
      imgSrc: '/assets/images/main-plan-card/guidance.png',
      text: 'Compassionate, professional guidance from our dedicated hotline, day or night.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/sms.png',
      text: 'Notifications to vets, rescues and councils within 20 miles when {petName} goes missing.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/missingSearch.png',
      text: 'Custom online profile to amplify {petName}’s visibility and boost recovery efforts.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/poster.png',
      text: 'Custom missing pet posters and proven reunification tips, tailored for adventurous cats.',
    },
    {
      
      imgSrc: '/assets/images/main-plan-card/mobiliseComm.png',
      text: `Missing pet SMS alerts to all pet keepers in a 5-mile radius.`,
    },
  ];

  public mainCardContentForOutdoorCat = [
    {
      imgSrc: '/assets/images/main-plan-card/idIcon.png',
      text: 'All the coverage of identibase+ and be contacted when {petName}’s microchip is scanned.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/guidance.png',
      text: 'Compassionate, professional guidance from our dedicated hotline, day or night.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/sms.png',
      text: 'Notifications to vets, rescues and councils within 20 miles when {petName} goes missing.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/missingSearch.png',
      text: 'Custom online profile to amplify {petName}’s visibility and boost recovery efforts.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/poster.png',
      text: 'Custom missing pet posters and proven reunification tips, tailored for adventurous cats.',
    },
    {
      imgSrc: '/assets/images/main-plan-card/mobiliseComm.png',
      text: `Missing pet SMS alerts to all pet keepers in a 5-mile radius.`,
    },
  ];

  public getFeaturesFor(plan: string): any[] {
    return this.plansFeatures[plan];
  }

  public getMainPlanContent(petName: string, thereIsOnlyOneCat?: boolean, isOutdoors?: boolean) {
    if (thereIsOnlyOneCat) {
      if (isOutdoors) {
        return this.mainCardContentForOutdoorCat.map((content) => {
          return {
            ...content,
            text: content.text.replace('{petName}', petName),
          };
        });
      } else {
        return this.mainCardContentForIndorCat.map((content) => {
          return {
            ...content,
            text: content.text.replace('{petName}', petName),
          };
        }); 
      }
    }
    return this.mainCardContent.map((content) => {
      return {
        ...content,
        text: content.text.replace('{petName}', petName),
      };
    });
  }
}
